let swipers = null;

$(document).on('turbolinks:before-cache', () => {
  if (swipers) {
    swipers.forEach(swiper => {
      swiper.destroy();
    });
    swipers = null;
  }
});

$(document).on('turbolinks:load', async () => {
  const node = document.querySelector('article.v4.running-line');
  if (!node) { return; }

  const [{ default: Swiper }, { Autoplay }] = await Promise.all([
    import('swiper'),
    import('swiper/modules')
  ]);

  swipers = new Swiper('article.v4.running-line .swiper-v8', {
    wrapperClass: 'slides',
    slideClass: 'slide',
    grabCursor: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    loop: true,
    modules: [Autoplay],
    speed: 10000,
    freeMode: true,
    resistance: false,
    autoplay: {
      delay: 0
    }
  });
});
